export default __webpack_public_path__ + "static/media/GDPR.79ecd13a.png";